import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
    Block,
    BlockDes,
    PreviewCard,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    BackTo,
    responseData,
    loading,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
// import { blukUploadInventoryProducts } from "../../redux/fulfillmentCenter/action";
// import { useHistory } from "react-router-dom";
// import "./style.scss";
// import LoadingSpinner from "../../components/Loader/Loader";
// import AlertMessage from "../../components/SharedComponents/AlertMessage";
// import { loginAxios } from '../../../config/axios.config';
// import { useMutation, useQuery } from "@tanstack/react-query";
// import { toast, ToastContainer } from "react-toastify";
// import {Spinner } from "reactstrap";
// import {useSelector, useDispatch} from 'react-redux';

const HelpCenter = () => {

    return (
        <React.Fragment data-test="UploadBasedCurateProducts">
            <Head title="Upload based curate products"></Head>
            <Content page="component">

                <Block size="lg">
                    {/* <BlockHead>
                        <BlockHeadContent>
                            <BlockDes>
                                <h3>Bulk Update</h3>
                            </BlockDes>
                        </BlockHeadContent>
                    </BlockHead> */}


                    <BlockHead size="lg" wide="sm">
                        <BlockHeadContent>                         
                            {/* <BlockTitle tag="h2" className="fw-normal">
                                Help Center
                            </BlockTitle> */}
                            <BlockDes>
                                <h3>Help Center</h3>
                            </BlockDes>
                            <BlockDes className="mt-2">
                                <p className="lead">
                                    <a href="https://azafashions.freshservice.com/support/signup" target="_blank" style={{ textDecoration: 'underline' }}>Click here to raise and track queries</a>                                    
                                </p>
                            </BlockDes>
                        </BlockHeadContent>
                    </BlockHead>

                    {/* <PreviewCard>
                        <div className="bulk-upload">
                            <label>Upload CSV File</label>                           
                        </div>
                    </PreviewCard> */}

                </Block>
            </Content>
        </React.Fragment>
    );
};


export default HelpCenter;